<template>
  <div class="eqFormLayout">
    <b-form class="b-layout" @submit.prevent="">
    <div class="prop-node-formEquation"> 
      <span v-if="this.showRef">
        <div>{{$t('selectAReference')}}</div>   
        <b-col md="3" sm="12">
            <b-form-group
              id="prop-refSelector"
              label=""
              label-for="propRef-select"
            >
              <select
                class="form-control"
                id="profileId-select"
                @change="onChangeRefSelector($event)"
              >
                <option
                  v-for="pKey in this.propRefKeys"
                  :key="pKey"
                  :value="pKey"
                >
                  {{ pKey }}
                </option>
              </select>
            </b-form-group>
        </b-col> 
        <b-row>
          <b-col sm="12">
            <!-- <div v-if="this.properties.length == 0"> -->
            <!-- <div v-if="this.nodeEdited.ref.length == 0"> -->
            <div v-if="this.selectedRefProperties && this.selectedRefProperties.length == 0">
              {{$t('noAttributesForVisualization')}}<br />
            </div>
            <div v-else>
              <div>{{$t('reference')}}</div>
              <div class="row">
                <!-- <p class="h6">Selecione um atributo:</p> -->
                <div
                  class="
                    col-12
                    table-responsive-md table-wrapper-scroll-y
                    my-custom-scrollbar
                  "
                >
                  <!-- <table class="table table-hover table-striped"> -->
                  <table class="table table-hover table-bordered table-sm">
                    <!-- <thead class="thead-dark"> -->
                    <thead class="thead-light">
                      <th scope="col" style="cursor: default;" class="tbCol1">{{$t('property')}}</th>
                      <th scope="col" class="tbCol2">{{$t('description')}}</th>
                      <th scope="col" class="tbCol3">{{$t('equation')}}</th>
                      <th scope="col" class="tbCol4">{{$t('unity')}}</th>
                    </thead>
                    <tbody class="">
                      <template>
                        <tr>
                          <td  style="cursor: default;"                            
                            class="text-truncate tableTxt tbCol1"
                          >
                          {{ selectedRefProperties[0] }}                              
                          </td>
                          <td                              
                            class="text-truncate tableTxt tbCol2"
                          >
                            <b-form-input class="inputDataGrid" :id="'item-col2'" v-model="selectedRefProperties[1].caption" type="text"></b-form-input>
                          </td>
                          <td                              
                            class="text-truncate tableTxt tbCol3"
                          >
                          <b-form-input class="inputDataGrid" :id="'item-col3'" v-model="selectedRefProperties[1].equation" type="text"></b-form-input>
                          </td>
                          <td                              
                            class="text-truncate tableTxt tbCol4"
                            style="max-width: 100px"
                          >
                          <b-form-input class="inputDataGrid" :id="'item-col-'" v-model="selectedRefProperties[1].unit" type="text"></b-form-input>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>              
          </b-col>
        </b-row>
        <br/>
      </span>
      <b-row>
        <b-col sm="12">
          <div v-if="!this.nodeEdited.attrs || this.nodeEdited.attrs && this.nodeEdited.attrs.length == 0">
            {{$t('noAttributesForVisualization')}}<br />
          </div>
          <div v-else>
            <div>{{$t('nodeProperty')}}</div>
            <div class="row">
              <!-- <p class="h6">Selecione um atributo:</p> -->
              <div
                class="
                  col-12
                  table-responsive-md table-wrapper-scroll-y
                  my-custom-scrollbar
                "
              >
                <!-- <table class="table table-hover table-striped"> -->
                <table class="table table-hover table-bordered table-sm">
                  <!-- <thead class="thead-dark"> -->
                  <thead class="thead-light">
                    <th scope="col" style="cursor: default;" class="tbCol1">{{$t('property')}}</th>
                    <th scope="col" class="tbCol2">{{$t('description')}}</th>
                    <th scope="col" class="tbCol3">{{$t('equation')}}</th>
                    <th scope="col" class="tbCol4">{{$t('unity')}}</th>
                    <th scope="col" class="tbCol4">{{$t('apply')}}</th>
                  </thead>
                  <tbody class="">
                    <template>
                      <tr
                        v-for="(property, index) in this.attrs"
                        :key="index"
                      >
                        <td style="cursor: default;"                             
                          class="text-truncate tableTxt tbCol1"
                        >
                        {{ attrs[index].key }}                              
                        </td>
                        <td                              
                          class="text-truncate tableTxt tbCol2"
                        >
                          <b-form-input class="inputDataGrid" :id="'item-node-col2-'+ property[0]" v-model="attrs[index].refCalc.caption" type="text"></b-form-input>
                        </td>
                        <td                              
                          class="text-truncate tableTxt tbCol3"
                        >
                        <b-form-input class="inputDataGrid" :id="'item-node-col3-'+ property[0]" v-model="attrs[index].refCalc.equation" type="text"></b-form-input>
                        </td>
                        <td                              
                          class="text-truncate tableTxt tbCol4"
                          style="max-width: 100px"
                        >
                        <b-form-input class="inputDataGrid" :id="'item-node-col4-'+ property[0]" v-model="attrs[index].refCalc.unit" type="text"></b-form-input>
                        </td>
                        <td                              
                          class="text-truncate tableTxt tbCol5"
                          style="max-width: 100px"
                        >
                        <img class="exec-calc" src="@/assets/assinarEconfirmar.png" alt="Aplicar calculo" :title="$t('applyCalculus')" @click="testCalc(attrs[index])">
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      </div>
    </b-form>

    <b-modal
      id="show-test"
      size="md"
      hide-footer
      :title="$t('calculationResult')"
      :no-close-on-backdrop="true"
    >
      <MessageBox
      class='msgBox'
      :info="resultTest"
      modelname="show-test"
      />
    </b-modal>
  </div>
</template>

<script>
import MessageBox from "@/components/template/MessageBoxModal.vue";

  export default {
    name: "FormEquation",
    props: {
      nodeEdited: {
        type: Object,
        default: null
      },
    },

    components: {
      MessageBox
    },

    data() {
      return {
        propRefKeys: [],
        properties: [],
        selectedRefProperties: [],
        attrs: [],
        showRef: false,
        resultTest: ""
      }
    },

    watch:{     
    },

    methods: {
      onChangeRefSelector(event) {        
        if(event.target.value == ''){
          this.selectedRefProperties = []
        }
        this.updateRefProperties(this.selectedRefProperties[0], this.selectedRefProperties[1])
        this.selectedRefProperties = this.properties.find( 
          x => {
            return x[0] == event.target.value
          }
        )
      },
      updateRefProperties(k, v){
        if( !k ){
          return
        }
        this.nodeEdited.ref.set(k, v)
      },

      updateNodeProperties(){
        if(this.nodeEdited.attrs){
          this.attrs.forEach( atProp => {
            atProp.refCalc.caption =  atProp.refCalc.caption ? atProp.refCalc.caption : atProp.caption
            atProp.refCalc.unit = atProp.refCalc.unit ? atProp.refCalc.unit : atProp.unit
          })
          this.nodeEdited.attrs = this.attrs
        }
      },

      testCalc(prop){
        this.resultTest = "Falha no calculo "

        let result = prop.refCalc.calc(prop.mapping)
        if(result != -9999){
          prop.setResultCalc(result)
          this.resultTest = prop.text()
        }

        this.$bvModal.show("show-test");
      },
    },

    mounted() {
      if(this.nodeEdited.ref){
        this.properties = [...this.nodeEdited.ref.entries()]
        this.selectedRefProperties = this.properties[0]
        this.showRef = true
      }
      this.attrs = this.nodeEdited.attrs
      this.updateNodeProperties()
    },

    beforeMount() {
      if(this.nodeEdited.ref){
        this.propRefKeys = [...this.nodeEdited.ref.keys()]
      }
    },

    destroyed(){
      this.updateRefProperties(this.selectedRefProperties[0], this.selectedRefProperties[1])
      this.updateNodeProperties()
    }
    
  }
</script>

<style scoped>

.txtSelection {
  max-width: 100px;
  text-overflow: ellipsis;
}

.my-custom-scrollbar th {
  position: sticky;
  top: 0;
}

table {
  border-collapse: initial;
  border-spacing: initial;
}

.tableTxt {
  font-size: 1.3em;
  text-align: center;
}

 .tbCol1 {
   max-width: 100px;
 }

 .tbCol2 {
   max-width: 100px;
 }

 .tbCol3 {
   max-width: 100px;
 }

 .tbCol4 {
   max-width: 100px;
 }

 .eqFormLayout {
   padding: 8px;
 }

 .exec-calc{
   width: 20px;
 }

</style>